import { Reveal } from "./Reveal";
import Breadcrumbs from "./Breadcrumbs";

export default function ToolShell({ name, tagline, children, slug }) {
  return (
    <div className="pt-28 md:pt-32 pb-24">
      <div className="max-w-6xl mx-auto px-5 md:px-8">
        <Breadcrumbs items={[
          { name: "Home", path: "/" },
          { name: "Tools", path: "/tools" },
          { name, path: `/tools/${slug}` },
        ]} />
        <Reveal>
          <p className="mt-6 text-xs uppercase tracking-[0.2em] text-gold">{tagline}</p>
          <h1 className="mt-3 font-serif text-4xl sm:text-5xl md:text-6xl font-light tracking-tighter">{name}</h1>
        </Reveal>
        <div className="mt-10">{children}</div>
      </div>
    </div>
  );
}

export function Field({ label, children }) {
  return (
    <label className="block">
      <span className="text-xs uppercase tracking-[0.15em] text-muted-foreground">{label}</span>
      <div className="mt-2">{children}</div>
    </label>
  );
}

export const inputCls =
  "w-full bg-transparent border-b-2 border-border rounded-none px-0 py-2.5 text-lg outline-none focus:border-primary transition-colors placeholder:text-muted-foreground/50";

export function StatCard({ label, value, sub }) {
  return (
    <div className="rounded-2xl border border-border bg-card p-5 shadow-soft text-center">
      <p className="text-xs uppercase tracking-[0.15em] text-muted-foreground">{label}</p>
      <p className="mt-1 font-serif text-5xl text-primary">{value}</p>
      {sub && <p className="mt-1 text-xs text-gold">{sub}</p>}
    </div>
  );
}
